<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import type { ClassValue } from 'svelte/elements';
	import SkeletonBlock from '$lib/components/atoms/skeleton/SkeletonBlock.svelte';
	import SkeletonButton from '$lib/components/atoms/skeleton/SkeletonButton.svelte';
	import SkeletonText from '$lib/components/atoms/skeleton/SkeletonText.svelte';
	import PoiCardImage from '$lib/components/recommendation/getyourguide/GetYourGuideCardImage/GetYourGuideCardImage.svelte';
	import { type Snippet } from 'svelte';

	interface Props {
		icon?: IconName	;
		imageUrl?: string;
		isHovered?: boolean;
		isLoading?: boolean;
		isSquare?: boolean;
		class?: ClassValue;
		title?: Snippet;
		rate?: Snippet;
		buttons?: Snippet;
		onCardClick?: () => void;
	}

	const {
		icon,
		imageUrl,
		isHovered = false,
		isLoading = false,
		isSquare = false,
		class: classes,
		title,
		rate,
		buttons,
		onCardClick,
	}: Props = $props();
</script>

<!-- We add an easy on:click on the div for now because this PoiCardTemplate component will be reworked soon -->
<!-- This create nested "button" that is not ideal. TODO in the upcoming reworked component: make clear and distinct clickable area for cardClick and CTAClick -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
	class={['flex flex-col gap-1 relative rd-2 shadow-recommendation-card p-1 bg-neutral-weakest w-full b-0', classes]}
	onclick={() => onCardClick?.()}
>
	<div class="flex flex-grow w-full">
		{#if imageUrl}
			{#if isLoading}
				<SkeletonBlock borderRadius="8px" height="80px" width="80px" />
			{:else}
				<!-- TODO: replace the harcoded srcset value with an optimized object from the BFF	 -->
				<PoiCardImage
					color="gyg"
					hasShadow={false}
					isSmallImage
					srcset={{ w320: imageUrl }}
					{icon}
					{isHovered}
					{isSquare}
				/>
			{/if}
		{/if}
		<div class="flex flex-col flex-1 ml-1 w-full overflow-hidden">
			<div class="items-start grow-1">
				{#if title}
					{#if isLoading}
						<SkeletonText minWords={2} maxWords={2} minWordLength={15} maxWordLength={20} />
						<SkeletonText minWords={2} maxWords={2} minWordLength={10} maxWordLength={15} />
					{:else}
						{@render title?.()}
					{/if}
				{/if}
			</div>
			{#if rate}
				<div class="flex h-6 text-sm items-center text-coloredneutral-soft">
					{#if isLoading}
						<SkeletonText minWords={2} maxWords={2} minWordLength={10} maxWordLength={15} />
					{:else}
						{@render rate?.()}
					{/if}
				</div>
			{/if}
		</div>
	</div>
	{#if buttons}
		{#if isLoading}
			<SkeletonButton class="w-full" />
		{:else}
			<div class="flex flex-row gap-1">
				{@render buttons?.()}
			</div>
		{/if}
	{/if}
</div>
